import React, { lazy } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
const FluidFormPreview = () => {
  return <div className="w-full min-h-screen font-sans" data-id="element-489">
      <Navbar data-id="element-490" />
      <main className="container mx-auto px-4 py-12" data-id="element-491">
        <h1 className="text-3xl font-bold mb-6 text-center" data-id="element-492">
          FluidForm Preview
        </h1>
        <p className="text-gray-600 mb-8 text-center max-w-3xl mx-auto" data-id="element-493">
          Experience our AI-native form technology in action. This is a live
          preview of a FluidForm with multi-modal inputs and intelligent
          validation.
        </p>
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200" data-id="element-494">
          <iframe src="https://app.fluid-form.ai/ff/fluidform-landing-page-form" width="100%" height="500px" title="Form fluidform-landing-page-form" frameBorder="0" loading="lazy" data-id="element-495" />
        </div>
        <div className="mt-8 text-center" data-id="element-496">
          <p className="text-gray-500" data-id="element-497">
            Want to create your own intelligent forms?{' '}
            <a href="#" className="text-orange-500 hover:text-orange-600" data-id="element-498">
              Get started for free
            </a>
          </p>
        </div>
      </main>
      <Footer data-id="element-499" />
    </div>;
};
export default FluidFormPreview;